/** Shared AppKit ap-text-editor (CKEditor 5) configuration for GTW. */
export const GTW_APPKIT_TEXT_EDITOR_TOOLBAR: string[] = [
  'heading',
  '|',
  'bold',
  'italic',
  'underline',
  'link',
  '|',
  'bulletedList',
  'numberedList',
  '|',
  'blockQuote',
  'insertTable',
  '|',
  'undo',
  'redo',
];

export type GtwAppkitTextEditorConfig = Record<string, unknown>;

/** Build editor config with shared toolbar and a screen-specific placeholder. */
export function createGtwAppkitTextEditorConfig(placeholder: string): GtwAppkitTextEditorConfig {
  return {
    placeholder,
    toolbar: GTW_APPKIT_TEXT_EDITOR_TOOLBAR,
  };
}
